<template>
  <div class="flex flex-col items-center justify-center h-screen w-full bg-white">
    <div
      v-if="!longToken && !error.message"
      class="flex flex-col items-center gap-4"
    >
      <BaseLoadingSpinnerCircle class="text-icon-normal w-8 h-8" />
      <BaseText
        type="body"
        size="sm"
        class="text-text-muted"
      >
        Connecting your Facebook account...
      </BaseText>
    </div>

    <div
      v-else-if="error.message"
      class="flex flex-col items-center gap-4"
    >
      <div class="flex items-center justify-center w-12 h-12 bg-secondary-red-25 rounded-full p-2">
        <TagRemoveIcon class="text-secondary-red-100 text-xl w-full h-full" />
      </div>
      <BaseText
        type="label"
        size="lg"
        class="text-secondary-red-100"
      >
        Something went wrong
      </BaseText>
      <BaseText
        type="body"
        size="sm"
        class="text-text-muted text-center max-w-xs"
      >
        {{ error.message }}
      </BaseText>
      <BaseButton
        outlined
        @click="closeWindow"
      >
        <BaseText
          size="sm"
          class="text-text-muted"
        >
          Close window
        </BaseText>
      </BaseButton>
      <BaseText
        size="xs"
        class="text-text-disabled"
      >
        Error type: {{ error.isFacebookError ? 'Facebook' : 'Server' }}
      </BaseText>
    </div>

    <div
      v-else
      class="flex flex-col items-center gap-4"
    >
      <div class="flex items-center justify-center w-12 h-12 bg-secondary-green-25 rounded-full p-2">
        <CheckmarkIcon class="text-secondary-green-100 text-xl w-full h-full" />
      </div>
      <BaseText
        type="label"
        size="lg"
        class="text-secondary-green-100"
      >
        Successfully Connected!
      </BaseText>
      <BaseText
        type="body"
        size="sm"
        class="text-text-muted text-center max-w-xs"
      >
        Your Facebook account has been connected successfully. You can now close this window.
      </BaseText>
    </div>
  </div>
</template>

<script>
import ForeplayAPI from '@/api/foreplayServer'
import CheckmarkIcon from '../../components/globals/Icons/CheckmarkIcon.vue'
import TagRemoveIcon from '../../components/globals/Icons/TagRemoveIcon.vue'

export default {
  name: 'FacebookAuthSuccessView',
  components: {
    CheckmarkIcon,
    TagRemoveIcon
  },
  data () {
    return {
      accessToken: null,
      longToken: null,
      error: {
        message: null,
        isFacebookError: false
      }
    }
  },
  mounted () {
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')
    const state = urlParams.get('state')
    console.log(code, state)
    if (code) {
      this.accessToken = code
      this.createLongToken()
    } else {
      console.error('No authorization code found in URL')
      this.error = {
        message: 'No authorization code found in URL',
        isFacebookError: true
      }
    }
  },
  methods: {
    async createLongToken () {
      try {
        const redirectURI = window.location.origin + window.location.pathname
        const data = await ForeplayAPI.Users.createFBToken(this.accessToken, redirectURI)
        console.log(data)
        const accessTokenLong = data.access_token
        console.log(accessTokenLong)
        this.longToken = accessTokenLong
      } catch (e) {
        const errMessage = e.response?.data?.error
        const isFacebookError = e.response?.data?.isFacebookError
        console.error('Error creating long token:', e)
        this.error = {
          message: errMessage,
          isFacebookError
        }
      }
    },
    closeWindow () {
      window.close()
    }
  }
}
</script>
